import { CustomReportField } from "../models/CustomReportField";
import { CustomReportFieldType } from "../models/CustomReportFieldType";

export type CustomReportJsonEditorType = 'object' | 'array' | 'string' | 'number' | 'integer' | 'boolean' | 'null';

export type CustomReportJsonEditorSchema = {
    type: CustomReportJsonEditorType
    properties: any
    additionalProperties: boolean,
    minProperties?: number,
    not?: any,
    required: Array<string>
}

export class CustomReportJsonReportConfigurationService {

    public static getJsonEditorSchemaForField(field: CustomReportField): CustomReportJsonEditorSchema {
        if (field == null) throw new Error("field is required!");

        const schema: any = {
            properties: {},
            additionalProperties: true
        };

        const schemaType: CustomReportJsonEditorType | null = this.getSchemaTypeForFieldType(field.field_type);
        if (schemaType !== null) {
            schema.type = schemaType;
        }

        return schema;
    }

    private static getSchemaTypeForFieldType(fieldType: CustomReportFieldType | any): CustomReportJsonEditorType | null {
        switch (fieldType) {
            case CustomReportFieldType.Text:
                return 'string';
            case CustomReportFieldType.Number:
                return 'number';
            case CustomReportFieldType.Boolean:
                return 'boolean';
            case CustomReportFieldType.Array:
                return 'array';
            case CustomReportFieldType.Object:
            case CustomReportFieldType.Json:
                return 'object';
            default:
                return null;
        }
    }

    public static getJsonEditorSchemaForCustomReport(): CustomReportJsonEditorSchema {
        return {
            type: 'object',
            required: ["type"],
            properties: {
                type: { type: "string" },
                description: { type: "string" }
            },
            additionalProperties: true
        };
    }
}
